import { MotivoDelReclamoComponent } from '../components/asuntos-i-e/motivo-del-reclamo/motivo-del-reclamo.component';

export const COMPONENTS = [
  {
    name: 'Formulación del Reclamo Motivo del Reclamo',
    value: 'MotivoDelReclamoComponent',
    component: MotivoDelReclamoComponent,
    caso: 'Investigación',
  },
];
